import React, { useEffect, useState } from 'react'
import { Box, Typography, Button, Drawer, IconButton, InputLabel, FormControl, Select, MenuItem, TextField, FormHelperText, Dialog, DialogContent, ToggleButton, ToggleButtonGroup, Autocomplete } from '@mui/material'
import { Add, AddOutlined, ArrowCircleLeft, ArrowLeft, CancelOutlined, CloseOutlined, KeyboardArrowLeft, WestOutlined } from '@mui/icons-material'
import { ApiCreateFixit, ApiGetEntityType, ApiGetFixitList, ApiGetStates, ApiUpdateFixit, ApiuploadDocuments, SearchName } from '../../../apiService/Core/Apicall.tsx';
import { fetchClientList } from '../../../Redux/clientSlice.tsx';
import { fetchBusinessList } from '../../../Redux/businessSlice.tsx';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../Redux/Store';
import { FormikValues, useFormik } from 'formik';
import upload from '../../../assets/Project_Images/Icons/upload.png'
import * as Yup from "yup";
import imageCompression from 'browser-image-compression';
import Loading from "../../Loader/Loading.tsx";
import { toast } from 'react-toastify';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { setLoadingFalse, setLoadingTrue } from '../../../Config/Action/loadingActions.ts';




function FixIt() {
    const [openFilter, setOpenFilter] = useState<boolean>(false)
    const [refresh, setrefresh] = useState<boolean>(false)
    const [OpenDialog, setOpenDialog] = useState<boolean>(false)
    const [isUpdate, setisUpdate] = useState<boolean>(false)
    const [selectedBussiness, setselectedBusiness] = useState<string | number>('')
    const [selectedClient, setselectedClient] = useState<string>("MM");
    const [selectedVenue, setselectedVenue] = useState<string | number>('')
    const [cancelDescription, setcancelDescription] = useState<string>('')
    const { businessList } = useSelector((state: RootState) => state.busines);
    const { clientList, error } = useSelector((state: RootState) => state.client);
    const loading = useSelector((state: any) => state.loader.isLoading);
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const [fixitlist, setfixitlist] = useState<any[]>([])
    const dispatch = useDispatch()
    const [selectedId, setselectedId] = useState<any>(null)
    const [VenueList, setVenueList] = useState<any>([])
    // const [alignment, setAlignment] = React.useState('opn');
    const appdispatch = useDispatch<AppDispatch>();
    const [filteredVenues, setFilteredVenues] = useState<{ venueId: string; venueName: string }[]>([]);
    const [bigImg, setbigImg] = useState<boolean>(false)
    const [showImg, setshowImg] = useState<any>([])
    const [entitytypelist, setentitytypelist] = useState<any>([])
    const [selectedentitytype, setselectedentitytype] = useState<any>()
    const [statelist, setstatelist] = useState<any>([])
    const [searchvenue, setsearchvenue] = useState<any>('')
    const [selectedstate, setselectedestate] = useState<any>()
    const [alignment, setAlignment] = React.useState('opn');



    const images = showImg && showImg.map(img => ({
        original: img,
        thumbnail: img,
    }));

    const handleResize = () => {
        if (window.innerWidth >= 768) {
            setselectedId(0)
        }
    };

    useEffect(() => {
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);



    const handleRemove = (indexToRemove: number) => {
        const updatedImages = formik.values.fixitimages.filter((_, index) => index !== indexToRemove);
        formik.setFieldValue("fixitimages", updatedImages);
    };



    type FormValues = {
        venue: string;
        venueId: number;
        title: string;
        description: string;
        area: string;
        clientEntityId: string;
        fixitimages: File[]; // or string[] depending on your logic
    };

    const initialValues: FormValues = {
        venue: isUpdate ? fixitlist[selectedId]?.venueName : "",
        venueId: isUpdate ? fixitlist[selectedId]?.venueId : 0,
        title: isUpdate ? fixitlist[selectedId]?.title : '',
        description: isUpdate ? fixitlist[selectedId]?.description : '',
        area: isUpdate ? fixitlist[selectedId]?.area : '',
        clientEntityId: isUpdate ? fixitlist[selectedId]?.clientEntityId : selectedBussiness,
        fixitimages: isUpdate ? fixitlist[selectedId]?.images : []
    };
    useEffect(() => {
        if (isUpdate === true) {
            setselectedBusiness(fixitlist[selectedId]?.clientEntityId)
        }
    }, [isUpdate])
    // const fileupload = async (filePath: any, fileType: any) => {
    // const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    //     console.log("Admin UserId", userData.userId)
    //     const formData = new FormData();
    //     formData.append("userId", userData.userId);
    //     formData.append("fileType", fileType);
    //     formData.append("file", filePath); // Add a file
    //     try {
    //         const response: any = await ApiuploadDocuments(formData);
    //         console.log("Uplodaed Imagesstatus",response.status)
    //         console.log("Uplodaed Images;location",response.location)
    //         console.log("Uplodaed Images data",response.data)
    //         if (response.status) {
    //             // console.log("Uploaded File URL", response)
    //             formik.setFieldValue('fixitimage', [...formik.values.fixitimage,response.location])
    //         }
    //         console.log("FixItImages", formik.values.fixitimage)
    //     }
    //     catch (error) {
    //     }

    // }

    // const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    //     const file = event.target.files?.[0];

    //     if (file && file.type.startsWith("image/")) {
    //         try {
    //             dispatch(setLoadingTrue())
    //             const options = {
    //                 maxSizeMB: 1,
    //                 maxWidthOrHeight: 800,
    //                 useWebWorker: true,
    //             };
    //             const compressedFile = await imageCompression(file, options);

    //             // Upload the compressed file
    //             fileupload(compressedFile, 'profile_pic');
    //         } catch (error) {
    //             console.error("Image compression failed:", error);
    //             alert("Image compression failed. Please try again.");
    //         }
    //         finally {
    //             dispatch(setLoadingFalse())
    //         }
    //     } else {
    //         toast.error("Please upload a valid image file.");
    //     }
    // };

    const fileupload = async (filePath: File, fileType: string) => {
        const userData = JSON.parse(localStorage.getItem("userData") || "{}");

        const formData = new FormData();
        formData.append("userId", userData.userId);
        formData.append("fileType", fileType);
        formData.append("file", filePath);

        try {
            const response: any = await ApiuploadDocuments(formData);
            if (response.status) {
                return response.location; // Return uploaded file URL
            } else {
                toast.error("Upload failed.");
                return null;
            }
        } catch (error) {
            console.error("Upload error:", error);
            toast.error("Upload error occurred.");
            return null;
        }
    };
    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;

        if (!files || files.length === 0) {
            toast.error("No files selected.");
            return;
        }

        const validImages = Array.from(files).filter(file => file.type.startsWith("image/"));
        if (validImages.length === 0) {
            toast.error("Please upload valid image files.");
            return;
        }

        dispatch(setLoadingTrue());
        const uploadedURLs: string[] = [];

        try {
            const options = {
                maxSizeMB: 1,
                maxWidthOrHeight: 800,
                useWebWorker: true,
            };

            for (const file of validImages) {
                try {
                    const compressedFile = await imageCompression(file, options);
                    const uploadedURL = await fileupload(compressedFile, 'profile_pic');
                    if (uploadedURL) {
                        uploadedURLs.push(uploadedURL);
                    }
                } catch (err) {
                    console.error("Failed for one file:", err);
                    toast.error("A file failed to upload.");
                }
            }

            if (uploadedURLs.length > 0) {
                formik.setFieldValue('fixitimages', [...formik.values.fixitimages, ...uploadedURLs]);
            }

        } catch (error) {
            toast.error("Something went wrong.");
        } finally {
            dispatch(setLoadingFalse());
        }
    };


    const validationSchema = Yup.object({
        venue: Yup.string().trim().required('Venue is required'),
        venueId: Yup.number().required('Venue ID is required').min(1, 'Please select a valid venue'),
        title: Yup.string().trim().required('Title is required'),
        description: Yup.string().trim().required('Description is required'),
        area: Yup.string().trim().required('Area is required'),
        // clientEntityId: Yup.number().required('Client Entity is required'),
        fixitimages: Yup.array()
            .min(1, 'At least one image is required')
            .required('Images are required')

    });
    const onSubmit = async (values: FormikValues, action) => {
        const { venue,clientEntityId, ...rest } = values; // destructure venue out, keep the rest
        const updatedValues = {
            ...rest,
        };
        const updatedValues2 = {
            fixItId: fixitlist[selectedId]?.fixItId,
            title: formik.values.title,
            description: formik.values.description,
            area: formik.values.area,
            fixitimages: formik.values.fixitimages,
        };
        try {
            const response = isUpdate ? await ApiUpdateFixit(updatedValues2) : await ApiCreateFixit(updatedValues)
            toast.success(response.message)
            setcancelDescription('')
            setrefresh(!refresh)
        }
        catch (error) {
            const message =
                error?.response?.data?.message || // API error message
                error?.message ||                 // JS error message
                String(error);
            toast.error(message)
        }
        finally {
            action.resetForm()
            setisUpdate(false)
            setOpenFilter(false)
        }
    };

    const handlUpdateFixIt = async (fixitId: number, status: number) => {

        try {
            const data = {
                fixItId: fixitId,
                fixItStatusId: status,
                comment: cancelDescription
            }
            const res = await ApiUpdateFixit(data)
            if (res.status) {
                setcancelDescription('')
                setrefresh(!refresh)
                setOpenDialog(false)
            }
        } catch (error) {
            console.log("Error", error)
        }
    }
    const formik = useFormik({
        initialValues,
        validationSchema,
        validateOnChange: true, // Ensures validation only happens on blur or submit
        validateOnBlur: false,
        onSubmit,
        enableReinitialize: true
    });
    useEffect(() => {
        appdispatch(fetchClientList());
        appdispatch(fetchBusinessList(selectedClient));
    }, [appdispatch, selectedClient]);

    const getfixitlist = async () => {
        const data = `?userId=${userData?.userId}&fixItStatusCode=${alignment}`;

        try {
            const response = await ApiGetFixitList(data)
            setfixitlist(response.data)
        }
        catch (error) {
            toast.error(error.message)
        }
    }
    useEffect(() => {
        getfixitlist()
    }, [refresh, alignment])

    // useEffect(() => {
    //     const fetchVenues = async () => {
    //         try {
    //             const data = `?offset=0&limit=500&venueStatus=active&${selectedentitytype ? `&entityTypeId=${selectedentitytype}` : ''}${selectedstate ? `&state=${selectedstate}` : ''}${selectedstate ? `&state=${selectedstate}` : ''}${searchvenue.length > 0 ? `&searchVenue=${searchvenue}` : ''}${selectedClient !== ' ' ? `&clientGroupName=${selectedClient}` : ''}`;

    //             const response = selectedentitytype && await SearchName(data);
    //             if (response.status) {
    //                 const venues = response.data.map((venue: any) => ({
    //                     venueId: venue.venueId,
    //                     venueName: venue.venueName,
    //                 }));
    //                 setVenueList(venues);
    //                 setFilteredVenues(venues);

    //             }
    //         } catch (error) {
    //             console.error("API Error:", error);
    //         }
    //     };
    //     fetchVenues();
    // }, [selectedentitytype]);
    useEffect(() => {
        const fetchVenues = async () => {
            try {
                const data = `?offset=0${selectedBussiness ? `&clientEntityId=${selectedBussiness}` : ''}&clientGroupName=${selectedClient}&limit=20${searchvenue ? `&searchVenue=${searchvenue}` : ''}`;
                const response = await SearchName(data);
                if (response.status) {
                    const venues = response.data.map((venue: any) => ({
                        venueId: venue.venueId,
                        venueName: venue.venueName,
                    }));
                    setVenueList(venues);
                    setFilteredVenues(venues);

                }
            } catch (error) {
                console.error("API Error:", error);
            }
        };

        const timeout = setTimeout(() => {
            fetchVenues();
        }, 400);
        return () => { clearTimeout(timeout) }

    }, [selectedBussiness, searchvenue]);
    console.log("Venu List", VenueList)

    useEffect(() => {
        if (!formik.values.venue.trim()) {
            setFilteredVenues(VenueList);
            return;
        }

        const queryLower = formik.values.venue.toLowerCase();
        const filtered = VenueList.filter((venue) =>
            venue.venueName.toLowerCase().includes(queryLower)
        );

        filtered.sort((a, b) => {
            const aLower = a.venueName.toLowerCase();
            const bLower = b.venueName.toLowerCase();

            if (aLower === queryLower) return -1;
            if (bLower === queryLower) return 1;

            const aStartsWith = aLower.startsWith(queryLower);
            const bStartsWith = bLower.startsWith(queryLower);
            if (aStartsWith && !bStartsWith) return -1;
            if (!aStartsWith && bStartsWith) return 1;

            return aLower.indexOf(queryLower) - bLower.indexOf(queryLower);
        });

        setFilteredVenues(filtered);
    }, [formik.values.venue, VenueList]);

    useEffect(() => {
        const getstatelist = async () => {
            try {
                const data = `${selectedClient !== ' ' ? `?clientGroupName=${selectedClient}` : ''}`
                const res = await ApiGetStates(data)
                setstatelist(res.data)

            } catch (error) {
            }
        }
        selectedClient && getstatelist()
    }, [selectedClient])

    useEffect(() => {
        const getshoptype = async () => {
            try {
                const data = `?clientGroupName=${selectedClient}`
                const res = await ApiGetEntityType(data)
                if (res.data) {
                    setentitytypelist(res.data)
                }
            } catch (error) {
            }
        }
        if (selectedClient) { getshoptype() }
    }, [selectedClient])


    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string,
    ) => {
        newAlignment && setAlignment(newAlignment);
    };


    return (
        <Box className='w-100 d-flex flex-md-row flex-column pb-3' height='calc(100vh - 70px)' overflow='auto'>
            <Box
                display={{
                    xs: selectedId !== null ? "none" : "block",
                    sm: "block",
                }}
                className="col-md-4 col-12 h-100 pt-3 mytask" position='relative' sx={{ borderRight: '1px solid #a0a0a0' }}>
                <Box className="d-flex justify-content-center mb-0">
                    <Box className="col-8  pb-lg-0 mb-0">
                        <ToggleButtonGroup
                            className="row w-100 phone-menue phone-menue2 m-0 px-0 mx-auto"
                            exclusive

                            value={alignment}
                            onChange={handleChange}
                        >
                            <ToggleButton className="py-2 col-4" value="opn">
                                <Typography className="fs-18 fw-bold">
                                    Open
                                </Typography>
                            </ToggleButton>
                            <ToggleButton className="py-2  col-4" value="don">
                                <Typography className="fs-18 fw-bold">
                                    Closed
                                </Typography>
                            </ToggleButton>
                            <ToggleButton className="py-2  col-4" value="can">
                                <Typography className="fs-18 fw-bold">
                                    Cancelled
                                </Typography>
                            </ToggleButton>

                        </ToggleButtonGroup>
                    </Box>
                </Box>
                <Box overflow='auto' height='calc(100vh - 100px)'>
                    {fixitlist && fixitlist.map((item, index) => (
                        <Box className='px-3 py-2' maxHeight='calc(100vh - 140px)' overflow='auto' onClick={() => { setselectedId(index) }}>
                            <Box mb={2} sx={{ borderRadius: '10px', border: '1px solid #ccc' }} bgcolor={selectedId === index ? '#E3DDD1' : ''} className='d-flex align-items-stretch p-2' gap={2}>
                                <Box sx={{ borderRadius: '10px', border: '1px solid #ccc' }} src={item.images[0]} component='img' alt='img' height={{ xs: "100px", md: '125px' }} width={{ xs: "100px", md: '150px' }}></Box>
                                <Box className='ms-2'>
                                    <Typography borderRadius='5px' py='5px' px={2} className='mb-5 bg-second' variant='caption'>{item.fixItStatusDesc}</Typography>
                                    <Typography variant='body2' className='fw-bold mt-2'>{item.title}</Typography>
                                    <Typography variant='body2'>{item.description}</Typography>
                                    <Typography variant='caption'><span className='fw-bold'>Location:</span>{item.area}</Typography>
                                </Box>
                            </Box>
                        </Box>
                    ))}

                </Box>
                <Button className='button-primary p-0' sx={{ position: 'absolute', zIndex: 99, bottom: 40, right: 20 }} onClick={() => { setOpenFilter(!openFilter) }}><span className='m-0 p-0' style={{ fontSize: '32px' }}>+</span></Button>
            </Box>
            <Box className="col-md-8 col-12  p-md-4 p-2  pb-2 d-flex flex-column">
                {selectedId !== null && fixitlist[selectedId] && (
                    <>
                        <Box className='mb-2 p-0'><IconButton onClick={() => setselectedId(null)}  ><WestOutlined /></IconButton></Box>
                        <Box className='flex-1'>
                            <Typography borderRadius='5px' py='5px' px={2} className='mb-5 bg-second' variant='caption'>{fixitlist[selectedId].fixItStatusDesc}</Typography>
                            <Box className='d-flex my-2 align-items-center justify-content-between'>
                                <Typography variant='h6' className='fw-bold mt-2'>{fixitlist[selectedId].title}</Typography>
                                <Typography variant="body2">
                                    <span className="fw-bold">Added on:</span>{' '}
                                    {new Date(fixitlist[selectedId].createdOn).toLocaleString('en-GB', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: true
                                    }).replace(',', ' |')}
                                </Typography>
                            </Box>
                            <Box mb={2} className='d-flex align-items-start' gap={1}>
                                <Box className='col-8 p-0' sx={{ borderRadius: '10px', border: '1px solid #a0a0a0' }} src={fixitlist[selectedId].images[0]} onClick={() => { setshowImg(fixitlist[selectedId].images); setbigImg(true) }} component='img' alt='img' height='300px'></Box>
                                <Box className='p-0 pe-2 col-4 d-flex flex-wrap justify-content-between align-items-center'>
                                    {fixitlist && fixitlist[selectedId].images.map((item: any, index: number) => (
                                        index !== 0 && (<Box className='p-0 w-49' key={index} sx={{ borderRadius: '10px', border: '1px solid #a0a0a0' }} src={item} component='img' onClick={() => { setshowImg(fixitlist[selectedId].images); setbigImg(true) }} height='150px' alt='img'></Box>)
                                    ))}
                                </Box>
                            </Box>
                            {/* <Box mb={2} sx={{ borderRadius: '10px', border: '1px solid #a0a0a0' }} src={fixitlist[selectedId].images[0]} component='img' alt='img' height='300px' width='100%'></Box> */}
                            <Typography variant='body1' className='mb-2'><span className='fw-bold'>Location:</span>{fixitlist[selectedId].area}</Typography>
                            <Typography variant='body1'>
                                {fixitlist[selectedId].description}
                            </Typography>
                        </Box>
                        {alignment === 'opn' && (
                            <Box height='fit-content' className='px-2 mt-auto pb-0 pt-3 d-flex apign-items-center justify-content-between' sx={{ borderTop: '1px solid #a0a0a0' }}>
                                <Button className='button-secondary-outlined py-2 px-4' onClick={() => { setOpenDialog(true) }} variant='outlined'>Cancel Request</Button>
                                <Button className='button-primary py-2 px-4' onClick={() => { setOpenFilter(true); setisUpdate(true) }}>Update Request</Button>
                            </Box>
                        )}
                    </>

                )}
            </Box>





            <Drawer
                anchor="right"
                PaperProps={{
                    sx: { width: 500, maxWidth: '95%' },

                }} open={openFilter}
                onClose={() => { setOpenFilter(false); setisUpdate(false); }}
            >
                <Box className='d-flex align-items-center justify-content-between p-2 px-4'>
                    <Typography variant='h6' className='fw-bold'>Log a  Fix It issue</Typography>
                    <IconButton onClick={() => { setOpenFilter(false); setisUpdate(false) }}>
                        <CancelOutlined />
                    </IconButton>
                </Box>
                <hr className='m-0' />
                <Box className='p-2 px-3'>
                    <form
                        className="d-flex flex-column justify-content-between h-100"
                        onSubmit={formik.handleSubmit}
                    >
                        {!isUpdate && (
                            <>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label" shrink={false}>
                                        {" "}
                                        <span>
                                            Select Client{" "}
                                            {/* <sup>
                                                <i className="fa-solid fa-star-of-life star"></i>
                                            </sup> */}
                                        </span>
                                    </InputLabel>
                                    <Select
                                        disabled={isUpdate}
                                        labelId="demo-simple-select-label"
                                        aria-placeholder="Select the Time"
                                        value={selectedClient}
                                        onChange={(e) => {
                                            setselectedClient(e.target.value);
                                            formik.setFieldValue("venue", '');
                                            formik.setFieldValue("venueId", '');
                                        }}
                                        MenuProps={{
                                            disablePortal: false, // Ensures dropdown is rendered inside the parent DOM
                                        }}
                                    >
                                        {clientList?.map((option, index) => (
                                            <MenuItem key={index} value={option?.clientGroupName}>
                                                {option?.clientGroupName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label" shrink={false}>
                                        {" "}
                                        <span>
                                            Select Business{" "}
                                            {/* <sup>
                                                <i className="fa-solid fa-star-of-life star"></i>
                                            </sup> */}
                                        </span>
                                    </InputLabel>
                                    <Select
                                        disabled={isUpdate}
                                        labelId="demo-simple-select-label"
                                        aria-placeholder="Select the Time"
                                        value={selectedBussiness}
                                        onChange={(e) => {
                                            setselectedBusiness(e.target.value);
                                            formik.setFieldValue("venue", '');
                                            formik.setFieldValue("venueId", '');
                                        }}
                                        MenuProps={{
                                            disablePortal: false,
                                        }}
                                    >
                                        {businessList?.map(
                                            (option, index) =>
                                                option?.entityName?.length > 0 && (
                                                    <MenuItem key={index} value={option?.clientEntityId}>
                                                        {option?.entityName}
                                                    </MenuItem>
                                                )
                                        )}
                                    </Select>
                                </FormControl>
                                {/* <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label" shrink={false}>
                                        {" "}
                                        <span>
                                            Select Task Type{" "}

                                        </span>
                                    </InputLabel>
                                    <Autocomplete
                                        disablePortal
                                        value={
                                            entitytypelist.find((option) => option?.entityTypeId === selectedentitytype) || null
                                        }
                                        options={entitytypelist}
                                        getOptionLabel={(option: any) => option?.entityTypeName}
                                        renderInput={(params) => <TextField  {...params} />}
                                        onChange={(event, newValue) => {
                                            setselectedentitytype(newValue?.entityTypeId)
                                        }}
                                    />
                                </FormControl>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label" shrink={false}>
                                        {" "}
                                        <span>
                                            Select State{" "}
                                            <sup>
                                                <i className="fa-solid fa-star-of-life star"></i>
                                            </sup>
                                        </span>
                                    </InputLabel>
                                    <Autocomplete
                                        disablePortal
                                        value={
                                            statelist.find((option) => option?.state === selectedstate) || null
                                        }
                                        options={statelist}
                                        getOptionLabel={(option: any) => option?.state}
                                        renderInput={(params) => <TextField  {...params} />}
                                        onChange={(event, newValue) => {
                                            setselectedestate(newValue?.state)
                                        }}
                                    />
                                </FormControl> */}

                                <FormControl
                                    fullWidth
                                    error={formik.touched.venue && Boolean(formik.errors.venue)}
                                >
                                    <InputLabel shrink={false}>
                                        <span>
                                            Select Site{" "}
                                            <sup>
                                                <i className="fa-solid fa-star-of-life star"></i>
                                            </sup>
                                        </span>
                                    </InputLabel>
                                    <Autocomplete
                                        disabled={isUpdate}
                                        options={VenueList?.filter((v: any) => v.venueName !== '') || []}
                                        getOptionLabel={(option) => option?.venueName || ""}
                                        value={
                                            VenueList.find(
                                                (venue: any) => venue.venueId === formik.values.venueId
                                            ) || null
                                        }
                                        onChange={(e, selectedVenue) => {
                                            formik.setFieldValue("venueId", selectedVenue?.venueId || "");
                                            formik.setFieldValue("venue", selectedVenue?.venueName || "");
                                        }}
                                        onInputChange={(_, newInputValue) => {
                                            setsearchvenue(newInputValue); // 🔹 Update searchVenue on typing
                                        }}

                                        onBlur={formik.handleBlur}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                name="venue"
                                                placeholder="Please Select the site"
                                                error={formik.touched.venue && Boolean(formik.errors.venue)}
                                            />
                                        )}
                                    />

                                    {formik.touched.venue && typeof formik.errors.venue === "string" && (
                                        <FormHelperText>{formik.errors.venue}</FormHelperText>
                                    )}
                                </FormControl>

                            </>
                        )}

                        <FormControl fullWidth error={formik.touched.title && Boolean(formik.errors.title)}>
                            <TextField
                                fullWidth

                                label={
                                    <span>
                                        Title For FIXIT{" "}
                                        <sup>
                                            <i className="fa-solid fa-star-of-life star"></i>
                                        </sup>
                                    </span>
                                }
                                InputLabelProps={{ shrink: false }}
                                name="title"
                                value={formik.values.title}
                                onChange={(e) => formik.setFieldValue("title", e.target.value)}
                                onBlur={formik.handleBlur}
                                error={formik.touched.title && Boolean(formik.errors.title)}
                                helperText={
                                    formik.touched.title && typeof formik.errors.title === 'string'
                                        ? formik.errors.title
                                        : ""
                                }
                            />
                        </FormControl>
                        {/* <FormControl fullWidth error={formik.touched.area && Boolean(formik.errors.area)}>
                            <TextField
                                fullWidth

                                label={
                                    <span>
                                        Area{" "}
                                        <sup>
                                            <i className="fa-solid fa-star-of-life star"></i>
                                        </sup>
                                    </span>
                                }
                                InputLabelProps={{ shrink: false }}
                                name="title"
                                value={formik.values.area}
                                onChange={(e) => formik.setFieldValue("area", e.target.value)}
                                onBlur={formik.handleBlur}
                                error={formik.touched.title && Boolean(formik.errors.area)}
                                helperText={
                                    formik.touched.area && typeof formik.errors.area === 'string'
                                        ? formik.errors.area
                                        : ""
                                }
                            />
                        </FormControl> */}
                        <FormControl fullWidth error={formik.touched.area && Boolean(formik.errors.area)}>
                            <InputLabel shrink={false}>
                                <span>
                                    Area{" "}
                                    <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                    </sup>
                                </span>
                            </InputLabel>
                            <Select
                                fullWidth
                                name="area"
                                value={formik.values.area}
                                onChange={(e) => formik.setFieldValue("area", e.target.value)}
                                onBlur={formik.handleBlur}
                                error={formik.touched.area && Boolean(formik.errors.area)}
                            >
                                <MenuItem value="">
                                    <em>Select Area</em>
                                </MenuItem>
                                <MenuItem value="Exterior signage">Exterior signage</MenuItem>
                                <MenuItem value="Exterior">Exterior</MenuItem>
                                <MenuItem value="Entry">Entry</MenuItem>
                                <MenuItem value="Restroom">Restroom</MenuItem>
                                <MenuItem value="TAB">TAB</MenuItem>
                                <MenuItem value="Gaming Room">Gaming Room</MenuItem>
                                <MenuItem value="Bar">Bar</MenuItem>
                                <MenuItem value="Bistro">Bistro</MenuItem>
                                <MenuItem value="Bottle shop">Bottle shop</MenuItem>
                                <MenuItem value="Beer Garden">Beer Garden</MenuItem>
                                <MenuItem value="Other">Other</MenuItem>
                                <MenuItem value="Fitting room">Fitting room</MenuItem>
                                <MenuItem value="Register counter">Register counter</MenuItem>
                                <MenuItem value="Shop floor">Shop floor</MenuItem>
                                <MenuItem value="Warehouse">Warehouse</MenuItem>
                                <MenuItem value="Car yard">Car yard</MenuItem>
                                <MenuItem value="Showroom">Showroom</MenuItem>
                                <MenuItem value="Bus exterior">Bus exterior</MenuItem>
                                <MenuItem value="Bus Interior">Bus Interior</MenuItem>
                                <MenuItem value="Vessel interior">Vessel interior</MenuItem>
                                <MenuItem value="Vessel Screens">Vessel Screens</MenuItem>
                                <MenuItem value="Wharf Screen">Wharf Screen</MenuItem>
                                <MenuItem value="Vessel exterior">Vessel exterior</MenuItem>
                                <MenuItem value="Wharf">Wharf</MenuItem>
                                <MenuItem value="Kitchen">Kitchen</MenuItem>
                                <MenuItem value="Playroom">Playroom</MenuItem>
                                <MenuItem value="Reception">Reception</MenuItem>
                                <MenuItem value="Restaurant">Restaurant</MenuItem>
                                <MenuItem value="Outdoor dining area">Outdoor dining area</MenuItem>
                                <MenuItem value="Gym">Gym</MenuItem>
                                <MenuItem value="Facilities">Facilities</MenuItem>
                            </Select>
                            {formik.touched.area && formik.errors.area && (
                                <FormHelperText error>
                                    {typeof formik.errors.area === 'string' ? formik.errors.area : ""}
                                </FormHelperText>
                            )}
                        </FormControl>
                        <FormControl fullWidth error={formik.touched.description && Boolean(formik.errors.description)}>
                            <TextField
                                fullWidth
                                label={
                                    <span>
                                        Description{" "}
                                        <sup>
                                            <i className="fa-solid fa-star-of-life star"></i>
                                        </sup>
                                    </span>
                                }
                                InputLabelProps={{ shrink: false }}
                                name="description"
                                aria-label="demo-simple-label"
                                value={formik.values.description}
                                onChange={(e) => formik.setFieldValue("description", e.target.value)}
                                onBlur={formik.handleBlur}
                                error={formik.touched.description && Boolean(formik.errors.description)}
                                helperText={
                                    formik.touched.description && typeof formik.errors.description === "string"
                                        ? formik.errors.description
                                        : ""
                                }
                            />

                        </FormControl>
                        <FormControl className='mt-3'>
                            <label htmlFor="file-upload" className='form-caption'>
                                <span>
                                    Fix It Image{" "}
                                    <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                    </sup>
                                </span>

                                <Box className='mt-2 d-flex align-items-center justify-content-center' height={200} width={{ xs: '100%', md: '200px !important' }} border='1px dashed #00000033' borderRadius={5}>
                                    <input
                                        type="file"
                                        id="file-upload"
                                        accept="image/*"
                                        multiple
                                        style={{ display: "none" }}
                                        onChange={handleFileChange}

                                    />
                                    <Box className='d-flex flex-column align-items-center justify-content-center'>
                                        <Box component='img' height={36} width={36} src={upload}></Box>
                                        <Typography className='form-caption'>Upload Here</Typography>
                                    </Box>
                                </Box>
                            </label>
                            {formik.touched.fixitimages && formik.errors.fixitimages && (
                                <FormHelperText error>
                                {typeof formik.errors.fixitimages === 'string' ? formik.errors.fixitimages : ""}
                                </FormHelperText>
                            )}
                        </FormControl>
                        <Box className='mt-3 d-flex align-items-start flex-wrap' gap={2}>
                            {formik.values.fixitimages && formik.values.fixitimages.map((item, index) => (
                                <Box className="image-container mr-1" key={index} position="relative" width="fit-content" borderRadius='10px' border='1px solid black'>
                                    <Box
                                        component="img"
                                        className="uploadedImg"
                                        alt="img"
                                        src={item}
                                        height={100}
                                        width="auto"
                                    />
                                    <Box className="cancel-button">
                                        <CancelOutlined sx={{ color: 'black' }} onClick={() => handleRemove(index)}></CancelOutlined>
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                        <Button className='button-primary w-50 mx-auto  mt-4  px-4 py-2' type='submit'>{isUpdate ? 'Update' : 'Submit'}</Button>
                    </form>
                </Box>
            </Drawer>

            <Dialog open={OpenDialog} onClose={() => { setOpenDialog(false); setcancelDescription('') }} PaperProps={{
                sx: {
                    width: '400px !important',
                    maxWidth: 'none',
                },
            }}>
                <DialogContent>
                    <Box className='p-0'>
                        <Box className='d-flex mb-2 align-items-center justify-content-between'>
                            <Typography variant='h6' className='fw-bold'> Cancellation</Typography>
                            <IconButton onClick={() => { setOpenDialog(false); setcancelDescription('') }}><CancelOutlined></CancelOutlined></IconButton>
                        </Box>
                        <FormControl fullWidth className="mb-3">
                            <InputLabel shrink={false} className='mb-2' htmlFor="cancel-description">
                                <span>
                                    Cancellation Reason{" "}
                                    <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                    </sup>
                                </span>
                            </InputLabel>
                            <textarea
                                id="cancel-description"
                                name="description"
                                style={{ fontSize: '16px' }}
                                className='px-3 py-2'
                                value={cancelDescription}
                                onChange={(e) => setcancelDescription(e.target.value)}
                                rows={4}

                            />
                        </FormControl>

                        <Button onClick={() => { handlUpdateFixIt(fixitlist[selectedId]?.fixItId, 3) }} fullWidth className='button-primary py-2'>Cancel Request</Button>
                    </Box>
                </DialogContent>
            </Dialog>
            <Dialog className='fulldialog' open={bigImg} onClose={() => { setbigImg(false) }}>
                <DialogContent>
                    <Box position='relative' sx={{
                        maxHeight: 'calc(100vh - 500px) !important',
                        // backgroundColor: 'green',
                        '.image-gallery-center': {
                            backgroundColor: 'transparent',
                            maxHeight: 'calc(100vh - 180px)!important'
                        },
                        '.image-gallery-svg': {
                            color: '#ADB792'
                        }
                    }}>
                        <IconButton
                            onClick={() => setbigImg(false)}
                            sx={{ position: 'absolute', top: 8, right: 8, zIndex: 10, }}
                        >
                            <CloseOutlined sx={{ fontSize: '48px' }} />
                        </IconButton>
                        <ImageGallery items={images} showPlayButton={false} />
                    </Box>
                </DialogContent>
            </Dialog>

            {loading && <Loading />}

        </Box>


    )
}

export default FixIt
